import { axios } from '@/utils/request'

export function getAnnouncementList (queryParam) {
  return axios({
    url: '/Announcement/page',
    method: 'get',
    params: queryParam
  })
}

export function addObj (obj) {
  return axios({
    url: '/Announcement/saveBySchool/',
    method: 'post',
    data: obj
  })
}

export function getObj (id) {
  return axios({
    url: '/Announcement/' + id,
    method: 'get'
  })
}

export function delObj (id) {
  return axios({
    url: '/Announcement/' + id,
    method: 'delete'
  })
}

export function putObj (obj) {
  return axios({
    url: '/Announcement',
    method: 'put',
    data: obj
  })
}

export function delBatchObj (ids) {
  return axios({
    url: '/Announcement/deleteBatch/' + ids,
    method: 'delete'
  })
}
